var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.7619 10.7618L1.2381 1.23804M10.7619 1.23804L1.2381 10.7618","stroke":"#E3D8F0","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Close.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Close;

Close.default = Close;
